import Styled from "styled-components";

export const Container = Styled.div`
`;

export const ContainerGrid = Styled.div`
  display: grid;
  grid-gap: 10px;
  grid-auto-flow: ${(props) => props.direction || "row"};
  grid-template-columns: 20px 75% 40px;
  margin-bottom: 10px;
`;

export const Label = Styled.h1`
`;
export const Space = Styled.div`
`;

export const EmptyCard = Styled.div`

  #goHomeButton {
    margin-top: 80px;
    margin-bottom: 180px;
  }
`;

export const Trash = Styled.div`
`;

export const Radio = Styled.input`
`;
export const Link = Styled.div`
`;

export const GroupIcons = Styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
export const TitleProduct = Styled.p`
`;

export const Box = Styled.div`
`;

export const Center = Styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const Line = Styled.div`
margin-top: 5px;
margin-bottom: 5px;
border: solid 1px #F0F2F5;
`;

export const Total = Styled.p`
font-weight: 700;
font-style: bold;
font-size: 16px;
line-height: 150%;
color: ${props => props.theme.whitelabel?.text_primary_color};
letter-spacing: 0%;
`

export const LabelText = Styled.p`
  font-weight: 500;
  font-style: medium;
  font-size: 16px;
  line-height: 150%;
  color: ${props => props.theme.whitelabel?.text_primary_color};
  letter-spacing: 0%;
`